export const getSceneTags = (
  source: {
    keywords?: string[];
    worldview?: string[];
  } | null
): string[] => [...(source?.keywords?.slice(0, 3) ?? []), ...(source?.worldview ?? [])];
